import { BaseUrls } from '../BaseUrlBuilder';

export class QuizEditorUrls extends BaseUrls {
  constructor() {
    super();
  }

  createStandardsUrl(quizId: number) {
    return `${this.baseUrl}/quizzes/${quizId}/standard`;
  }

  updateOrDeleteStandardsUrl(quizId: number, standardId: number) {
    return `${this.baseUrl}/quizzes/${quizId}/standard/${standardId}`;
  }
}
